import SingleColorPickerSelect from "./singleColorPickerSelect.container";

export default SingleColorPickerSelect;
